module.exports = {"previewCurrentPlan":"Il tuo piano attuale:"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/FeaturePreview/localization/it-IT/strings.json
// module id = 819
// module chunks = 0